import { firstDayOfWeekForRegion, fromWeekInfoDay, } from '@planter/common/src/locale/dates/firstDayOfWeek';
var cachedFirstDayOfWeek;
var fromIntlWeekInfo = function (languageTag) {
    var _a, _b;
    try {
        if (typeof Intl === 'undefined' || typeof Intl.Locale !== 'function') {
            return undefined;
        }
        // weekInfo è un getter su Chrome/Safari, getWeekInfo() un metodo su Firefox
        var intlLocale = new Intl.Locale(languageTag);
        var weekInfo = (_a = intlLocale.weekInfo) !== null && _a !== void 0 ? _a : (_b = intlLocale.getWeekInfo) === null || _b === void 0 ? void 0 : _b.call(intlLocale);
        return (weekInfo === null || weekInfo === void 0 ? void 0 : weekInfo.firstDay) ? fromWeekInfoDay(weekInfo.firstDay) : undefined;
    }
    catch (_c) {
        return undefined;
    }
};
var regionFromLanguageTag = function (languageTag) {
    try {
        if (typeof Intl !== 'undefined' && typeof Intl.Locale === 'function') {
            var locale = new Intl.Locale(languageTag);
            var maximized = typeof locale.maximize === 'function' ? locale.maximize() : locale;
            if (maximized.region) {
                return maximized.region;
            }
        }
    }
    catch (_a) {
        // si ricade sul parsing manuale del tag
    }
    var match = languageTag.match(/-([A-Za-z]{2})(?:-|$)/);
    return match === null || match === void 0 ? void 0 : match[1];
};
export var computeDeviceFirstDayOfWeek = function (languageTag) {
    var _a;
    if (!languageTag) {
        return firstDayOfWeekForRegion(undefined);
    }
    return ((_a = fromIntlWeekInfo(languageTag)) !== null && _a !== void 0 ? _a : firstDayOfWeekForRegion(regionFromLanguageTag(languageTag)));
};
export var getDeviceFirstDayOfWeek = function () {
    if (cachedFirstDayOfWeek === undefined) {
        cachedFirstDayOfWeek = computeDeviceFirstDayOfWeek(typeof navigator !== 'undefined' ? navigator.language : undefined);
    }
    return cachedFirstDayOfWeek;
};
